import type { AsyncData } from '#app'
import { useQuery, type ApiError, type OpenapiError } from '#imports'
import type { UseQueryFunctionOptions, UseQueryHandler, UseQueryOptions, UseQueryUrl } from '../../types'

export function useLazyQuery<TResponse, TError = ApiError<TResponse> | OpenapiError<TResponse> | Error | null>(requestOrHandler: UseQueryHandler<TResponse>, queryOptions: UseQueryFunctionOptions<TResponse>): AsyncData<TResponse, TError>
export function useLazyQuery<TResponse, TError = ApiError<TResponse> | OpenapiError<TResponse> | Error | null>(requestOrHandler: unknown, queryOptions: unknown): Promise<Awaited<AsyncData<TResponse, TError>>> {
    const preparedQueryOptions = {
        ...queryOptions as any,
        lazy: true,
        server: false,
    } satisfies Omit<UseQueryFunctionOptions<TResponse>, 'key'>

    if (typeof requestOrHandler === 'function') {
        return useQuery<TResponse, TError>(requestOrHandler as UseQueryHandler<TResponse>, preparedQueryOptions as UseQueryFunctionOptions<TResponse>)
    }
    else {
        return useQuery<TResponse, TError>(requestOrHandler as UseQueryUrl, preparedQueryOptions as UseQueryOptions<TResponse>)
    }
}
